import { css } from '@emotion/react';
import { Colors, Units } from '@weberus/ui/styles';

const container = css`
  width: 100vw;
  background-color: ${Colors.gray100};

  /** 375px 화면에서의 픽셀을 창 너비에 맞게 계산하는 용도 */
  --ratio: 100vw / 375;
  @media only screen and (min-width: ${Units.PC_WIDTH}px) {
    --ratio: ${Units.PC_WIDTH}px / 375;
  }

  & > * {
    margin: 0 auto;
  }
`;

export const Styles = {
  container,
};
